import { AssignmentRules } from './assignmentRules';

export class GetAssignmentRulesResponse {
  assignmentRules?: AssignmentRules[];
  assignmentRulesCount: number;

  constructor(assignmentRules: AssignmentRules[], assignmentRulesCount: number) {
    this.assignmentRules = assignmentRules;
    this.assignmentRulesCount = assignmentRulesCount;
  }
}
